var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.supplementaryHeatersProp.length || _vm.valveGroups.length
    ? _c(
        "div",
        { staticClass: "valve-picker" },
        [
          _c("h3", { staticClass: "heading" }, [
            _vm._v("Select heater & valves")
          ]),
          _vm._v(" "),
          _vm.supplementaryHeatersProp.length
            ? _c("div", { staticClass: "valve-type" }, [
                _c(
                  "h5",
                  {
                    staticClass: "valve-type-heading",
                    on: {
                      click: function($event) {
                        return _vm.toggleSupplementaryHeaterOpen()
                      }
                    }
                  },
                  [_vm._v("Supplementary Heater")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "options",
                    class: { hidden: !_vm.supplementaryHeaterOpen }
                  },
                  _vm._l(_vm.supplementaryHeatersProp, function(
                    supplementaryHeaterProp
                  ) {
                    return _c(
                      "div",
                      { key: supplementaryHeaterProp.id, staticClass: "item" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "heater",
                              value: "0"
                            },
                            domProps: {
                              checked:
                                _vm.supplementaryHeaterSelectedProp &&
                                _vm.supplementaryHeaterSelectedProp.id ==
                                  supplementaryHeaterProp.id
                            },
                            on: {
                              change: function($event) {
                                return _vm.toggleSupplementaryHeaterSelected(
                                  supplementaryHeaterProp
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(supplementaryHeaterProp.title))
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.valveGroups, function(valveGroup) {
            return _c(
              "div",
              { key: valveGroup.handle },
              [
                _c("ValveGroup", {
                  attrs: {
                    valveGroupProp: valveGroup,
                    valveGroupOpenProp: _vm.valveGroupOpen,
                    valveSelectedProp: _vm.valveSelectedProp,
                    suppHeaderSelectedProp: _vm.supplementaryHeater
                  },
                  on: {
                    valveGroupOpen: _vm.onValveGroupOpened,
                    valveSelected: _vm.onValveSelected
                  }
                })
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }